/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */
// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;
export default [[["𑄛𑄧𑄖𑄳𑄠𑄃𑄟𑄧𑄣𑄳𑄠𑄬", "𑄝𑄬𑄚𑄳𑄠𑄬", "𑄘𑄨𑄝𑄪𑄎𑄳𑄠", "𑄝𑄬𑄣𑄳𑄠𑄬", "𑄥𑄎𑄧𑄚𑄳𑄠", "𑄢𑄬𑄖𑄴"], u, u], u, [["04:00", "06:00"], ["06:00", "12:00"], ["12:00", "16:00"], ["16:00", "18:00"], ["18:00", "20:00"], ["20:00", "04:00"]]];
